import { motion } from "framer-motion";
import { ABOUT } from "@/constants/testIds";
import Spade from "@/components/Spade";
import { MapPin } from "lucide-react";

export default function About({ site }) {
    return (
        <section
            id="about"
            data-testid={ABOUT.root}
            className="relative py-24 md:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10 opacity-[0.04] pointer-events-none">
                <Spade
                    size={640}
                    className="absolute -right-24 top-1/2 -translate-y-1/2"
                />
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9 }}
                >
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        Who We Are
                    </p>
                    <h2
                        data-testid={ABOUT.heading}
                        className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--text-primary)]"
                    >
                        We do not do{" "}
                        <span className="italic text-[var(--accent-champagne)]">niches.</span>{" "}
                        <br className="hidden md:block" />
                        We do{" "}
                        <span className="font-fraktur text-[var(--accent-gold)]">domination.</span>
                    </h2>

                    <div className="mt-8 space-y-5 text-lg leading-relaxed text-[var(--text-secondary)] max-w-2xl">
                        <p>
                            Since 2020, Aestherium Media has grown and scaled social accounts across
                            every industry you can name: real estate, hotels, gyms, D2C brands,
                            coaches, marketers, service businesses. We do not specialise in one
                            niche. We specialise in{" "}
                            <span className="text-[var(--accent-champagne)]">making brands viral</span>{" "}
                            and turning that reach into revenue.
                        </p>
                        <p>
                            Most agencies make you choose: reach or revenue. We deliver both, at
                            the same time. More followers, more views, more actual enquiries and
                            sales, all through organic strategy. No paid ads. No shortcuts. No
                            inflated vanity metrics.
                        </p>
                        <p className="font-display italic text-[var(--accent-champagne)] text-xl md:text-2xl border-l-2 border-[var(--accent-gold)] pl-5">
                            Great content deserves distribution. We do not ask you to work harder.
                            We make what you already do travel further and sell better.
                        </p>
                    </div>

                    <div
                        data-testid={ABOUT.address}
                        className="mt-10 inline-flex items-center gap-3 text-sm text-[var(--text-secondary)] px-4 py-2 rounded-full border border-[var(--border-subtle)] bg-[rgba(255,255,255,0.02)]"
                    >
                        <MapPin size={14} className="text-[var(--accent-gold)]" />
                        Registered office · {site?.address || "Dehradun, Uttarakhand, India"}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
